export default __webpack_public_path__ + "static/media/tradegothicextended.b87ceac4.otf";